"use strict";
/**
 * Where tokens live is platform-specific — `localStorage` in the browser,
 * `expo-secure-store` on the courier phone, an encrypted file in the POS
 * desktop shell. The client only needs this interface, so `@restor/api-client`
 * itself stays free of any platform API (TZ §71).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageTokenStore = exports.MemoryTokenStore = void 0;
exports.toStoredTokens = toStoredTokens;
/**
 * Default store: keeps tokens in memory only. Safe everywhere and the right
 * choice for short-lived processes; swap it for a persistent one in an app that
 * must survive a reload.
 */
class MemoryTokenStore {
    tokens = null;
    get() {
        return this.tokens;
    }
    set(tokens) {
        this.tokens = tokens;
    }
    clear() {
        this.tokens = null;
    }
}
exports.MemoryTokenStore = MemoryTokenStore;
/**
 * Browser store backed by `localStorage`.
 *
 * Every read is guarded: `localStorage` throws in a private window with site
 * data blocked, and a crash there would take the whole app down on boot.
 */
class LocalStorageTokenStore {
    key;
    constructor(key = 'restor.tokens') {
        this.key = key;
    }
    get() {
        try {
            const raw = globalThis.localStorage?.getItem(this.key);
            return raw ? JSON.parse(raw) : null;
        }
        catch {
            return null;
        }
    }
    set(tokens) {
        try {
            globalThis.localStorage?.setItem(this.key, JSON.stringify(tokens));
        }
        catch {
            // Storage unavailable or full — the session simply won't survive a reload.
        }
    }
    clear() {
        try {
            globalThis.localStorage?.removeItem(this.key);
        }
        catch {
            // Nothing to do.
        }
    }
}
exports.LocalStorageTokenStore = LocalStorageTokenStore;
/** Builds a {@link StoredTokens} from an auth response's `expiresIn` seconds. */
function toStoredTokens(tokens) {
    return {
        accessToken: tokens.accessToken,
        refreshToken: tokens.refreshToken,
        expiresAt: Date.now() + tokens.expiresIn * 1000,
    };
}
//# sourceMappingURL=token-store.js.map